var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-button',{class:[_vm.cssClass],attrs:{"href":"javascript:;","loading-text":"Loading","type":_vm.type,"loading":_vm.waitingForOAuth},on:{"click":_vm.openAuthWindow}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }